var render = function render(){var _vm=this,_c=_vm._self._c;return _c('input',{attrs:{"id":_vm.id,"type":"tel","autocomplete":"off"},on:{"focus":function($event){return _vm.$emit('focus')},"blur":function($event){return _vm.$emit('blur')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }